import { Utils } from "@/plugins/utils";
import router from '@/router';
import moment from "moment";

export default {
	namespaced: true,
	state: {
		lstVea: [],
		lstVeaProduct: [],
		vea: {},
		veageracom: 1,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		
	},
	mutations: {
		set(state, lstVeaLet){
			const arr = lstVeaLet || [];
			// Só atualiza veavend/veacliente se houver itens na lista
			if (arr.length > 0) {
				state.vea.veavend = arr[0]?.veavend;
				state.vea.veacliente = arr[0]?.veacliente;
			}
			state.lstVeaProduct = arr.map(item => ({
				...item,
				veacomis: Number(item.veacomis || 0),
				veageracom: item.veageracom != null ? Number(item.veageracom) : 1
			}));

			state.veageracom = arr[0]?.veageracom || 1;
			state.update = arr.length > 0;
		},
		initForm(state){
			state.insert = true
			state.update = false
			state.lstVeaProduct = []
			state.veageracom = 1
			state.vea = {}
		},
		setParamsDataTable(state, payload){
			state.lstVea = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setList(state, lstVea) {
			state.lstVea = lstVea || [];
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, vea){
			await this._vm.$axios.get(`/Representative/CommissionByProduct/FindList/${vea.veavendcli}`)
			.then(response => {
				let lstVeaLet = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", lstVeaLet)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},	
		async insert(store, payloads = []) {
            if (!payloads || payloads.length === 0) return true;

            const valid = payloads.filter(p => p && p.veaproduto && (p.veacliente || p.veavend));
            if (valid.length === 0) return true;

            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true });
			
            const result = await this._vm.$axios.post("/Representative/CommissionByProduct/Insert", valid)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                })
                .catch(error => {
                    store.dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true });
                    return false;
                });

            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true });
            return result;
        },
        async update(store, payloads = []) {
            if (!payloads || payloads.length === 0) return true;

            const valid = payloads.filter(p => p && p.veaproduto && (p.veacliente || p.veavend));
            if (valid.length === 0) return true;

            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true });

            const result = await this._vm.$axios.put("/Representative/CommissionByProduct/Update", valid)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                 return true;
                })
                .catch(error => {
                    store.dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true });
                    return false;
                });

            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true });
            return result;
        },
        async delete(store, payloads = []) {
            if (!payloads || payloads.length === 0) return true;

            const valid = payloads.filter(p => p && p.veaproduto && (p.veacliente || p.veavend));
            if (valid.length === 0) return true;

            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true });

            const result = await this._vm.$axios.post("/Representative/CommissionByProduct/Delete", valid)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    return true;
                })
                .catch(error => {
                    store.dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true });
                    return false;
                });

            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true });
            return result;
        },
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/Representative/CommissionByProduct/FindList")
			.then(response => {
				let lstVea = Utils.ValidateAxiosResponse(response.data);
				store.commit("setList", lstVea);
				store.state.hasNext = (lstVea ? lstVea.length : 0) > store.state.itemsPerPage
			}).catch(error => {
				store.commit("setList", []);
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Representative/Representative/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.commit("setList", []);
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async printReportSalesByVendorRanking(store, { since , until, detail }){
			if (!since)
				since = moment().format("YYYY-MM-DDT00:00")
			if (!until)
				until = moment().format("YYYY-MM-DDT23:59")
				
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Representative/Representative/PrintReportSalesByVendorRanking", {
				since,
				until,
				detail
			})
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

				if(relatPath)
					store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })
				
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		

		
	}
}